import { ApolloClient, from, NormalizedCacheObject } from '@apollo/client'
import type { Resolvers, ApolloLink } from '@apollo/client'

import { AuthPageContextProps } from './ApolloConnector'
import { registerCacheForHydration, rehydrateCache } from './cacheHydration'
import createAuthErrorLink from './createAuthErrorLink'
import createCache from './createCache'
import type { CacheConfig } from './createCache'
import createLink from './createLink'

export interface ClientConfig {
  uri: string
  storeView: string
  resolvers?: Resolvers[]
  cache: CacheConfig
  authPages: AuthPageContextProps
  links?: ApolloLink[]
  restoreData?: NormalizedCacheObject
}

const createClient = ({
  uri,
  storeView,
  resolvers,
  cache: cacheConfig,
  authPages,
  links = [],
  restoreData,
}: ClientConfig) => {
  const cache = createCache(cacheConfig)
  rehydrateCache(cache, storeView)
  registerCacheForHydration(cache, storeView)
  if (restoreData) {
    cache.restore(restoreData)
  }

  const client = new ApolloClient<unknown>({
    link: from([
      ...links,
      createAuthErrorLink(authPages),
      createLink(uri, storeView),
    ]),
    cache,
    resolvers,
  })

  return client
}

export default createClient
